import { RichTextFormatter, translate, translateFormatter } from '@/core/localization/translate';
export const {
  deliveryFilterTitle,
  freeDeliveryRevampLabel,
  relayDeliveryRevampLabel,
  manoExpressExplanationTextTitle,
  manoExpressFilterName
} = translate({
  "deliveryFilterTitle": "Delivery",
  "relayDeliveryRevampLabel": "To a collection point",
  "freeDeliveryRevampLabel": "Free",
  "manoExpressExplanationTextTitle": "ManoExpress: free delivery by ManoMano",
  "manoExpressFilterName": "Free with"
});
export const manoExpressExplanationTextBody = translateFormatter<{
  tag: RichTextFormatter;
}>([{
  "type": 0,
  "value": "ManoExpress conditions"
}], undefined, undefined, "en");
export const manoExpressExplanationTextSubText = translateFormatter<{
  tag: RichTextFormatter;
}>([{
  "type": 0,
  "value": "ManoExpress sub text"
}], undefined, undefined, "en");